import script from "./goodsRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsRecords.vue?vue&type=script&setup=true&lang=js"

import "./goodsRecords.vue?vue&type=style&index=0&id=446ab379&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446ab379"]])

export default __exports__